module.exports = __webpack_public_path__ + "img/webflow.3e10feca.svg";